import { createAction } from '@reduxjs/toolkit';

import type { RawOptionGroupAPIData } from './option_groups.types';

type FetchOptionGroupFulfilledPayload = {
  templateId: number;
  optionGroups: RawOptionGroupAPIData[];
};

const fetchOptionGroups = {
  pending: createAction<number>('optionGroups/fetchOptionGroups/pending'),
  fulfilled: createAction<FetchOptionGroupFulfilledPayload>(
    'optionGroups/fetchOptionGroups/fulfilled'
  ),
  rejected: createAction('optionGroups/fetchOptionGroups/rejected'),
};

const fetchManyOptionGroups = createAction<number[]>('optionGroups/fetchManyOptionGroups');

const fetchOrderOptions = {
  pending: createAction('optionGroups/fetchOrderOptions/pending'),
  fulfilled: createAction<RawOptionGroupAPIData[]>('optionGroups/fetchOrderOptions/fulfilled'),
  rejected: createAction('optionGroups/fetchOrderOptions/rejected'),
};

export default { fetchOptionGroups, fetchManyOptionGroups, fetchOrderOptions };
